import { render, staticRenderFns } from "./codeQr.vue?vue&type=template&id=04642a02&scoped=true"
import script from "./codeQr.vue?vue&type=script&lang=js"
export * from "./codeQr.vue?vue&type=script&lang=js"
import style0 from "./codeQr.vue?vue&type=style&index=0&id=04642a02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04642a02",
  null
  
)

export default component.exports